import { Button } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import History from '../../Violation/History';

const Violation = ({ id }) => {
  return (
    <>
      <Link to={`/violation/create?id=${id}`}><Button type="primary">Update Data Pelanggaran</Button></Link>
      <div className="gx-mt-3">
        <History id={id} />
      </div>
    </>
  );
}

export default Violation;